export default function setPublicPath(path) {
    __webpack_public_path__ = path
}
